import { Button, Space } from 'antd';
import { useTranslation } from 'react-i18next';
import { Edit, DeviceAnalytics, Currency } from 'tabler-icons-react';
import { useNavigate } from 'react-router-dom';

import { isEnableToColumn } from '../../utils/isEnableToColumn';

export const useMyCompanyListColumns = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return [
    {
      key: 'name',
      dataIndex: 'name',
      title: t('myCompanies.name'),
      sorter: (a, b) => a.name.localeCompare(b.name),
    },
    {
      key: 'tax_id',
      dataIndex: 'tax_id',
      title: t('myCompanies.tax_id'),
    },
    {
      key: 'address',
      dataIndex: 'address',
      title: t('myCompanies.address'),
    },
    {
      key: 'city',
      dataIndex: 'city',
      title: t('myCompanies.city'),
    },
    {
      key: 'country',
      dataIndex: 'country',
      title: t('myCompanies.country'),
    },
    {
      key: 'is_enabled',
      dataIndex: 'is_enabled',
      title: t('myCompanies.is_enabled'),
      align: 'center',
      render: isEnableToColumn,
    },
    {
      key: 'files_analyzed',
      dataIndex: 'files_analyzed',
      title: 'Liczba plików',
      sorter: (a, b) => a.files_analyzed - b.files_analyzed,
    },
    {
      key: 'wcoxmlweb_analyzed',
      dataIndex: 'wcoxmlweb_analyzed',
      title: 'Liczba WcoWeb',
      sorter: (a, b) => a.wcoxmlweb_analyzed - b.wcoxmlweb_analyzed,
    },
    {
      key: 'actionColumn',
      title: '',
      align: 'center',
      render: row => (
        <Space size={2}>
          <Button type='link' onClick={() => navigate(`/front/my-companies/${row._id}`)}>
            <Edit />
          </Button>
          <Button type='link' onClick={() => navigate(`/front/my-companies/${row._id}/analytics`)}>
            <DeviceAnalytics />
          </Button>
          <Button type='link' onClick={() => navigate(`/front/companies/${row._id}/wcoxml-web`)}>
            <Currency />
          </Button>
        </Space>
      ),
    },
  ];
};
